document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    const pickupTitles = document.querySelectorAll('h4.pickup-location__h4');

    pickupTitles.forEach((title) => {
      if (!title.dataset.modified) {
        const h1 = document.querySelector('h1');
        const productTitle = h1?.innerText?.trim();
        const productVendor = title.closest('main')?.querySelector('p')?.innerText?.trim();

        if (productTitle && productVendor) {
          title.innerText = `${productTitle} (${productVendor})`;
        } else {
          title.innerText = 'surfdevils.com';
        }

        title.dataset.modified = 'true';
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
